import { IMaintenanceListResponse } from '@/store/api/maintenanceApi';
import { getTicketStatusInfo, TICKET_STATUS_COLORS } from './ticketStatus';
import { formatDateWithTime } from './maintenance';

export type TimelineNodeState = 'done' | 'active' | 'upcoming';

export interface StatusTimelineNode {
  key: 'submitted' | 'current' | 'final';
  label: string;
  date: string | null;
  state: TimelineNodeState;
  color: string;
}

const fmt = (d?: string): string | null => (d ? formatDateWithTime(d) : null);

/**
 * Derive a 3-milestone timeline (Submitted -> current status -> Completed/Cancelled)
 * from the ticket, reusing the existing status color/label model. Honest about what
 * we know: the middle node reflects the *current* mapped status when active.
 */
export const buildStatusTimeline = (ticket: IMaintenanceListResponse): StatusTimelineNode[] => {
  const info = getTicketStatusInfo(ticket);
  const isCancelled = info.status === 'cancelled';
  const isTerminal = info.progress === 3; // completed or cancelled
  const isActiveMiddle = info.progress === 2;

  return [
    {
      key: 'submitted',
      label: 'Submitted',
      date: fmt(ticket.createdOn),
      state: 'done',
      color: TICKET_STATUS_COLORS.new,
    },
    {
      key: 'current',
      label: isActiveMiddle ? info.label : 'In progress',
      date: isActiveMiddle ? fmt(ticket.updatedOn) : null,
      state: info.progress >= 2 ? (isTerminal ? 'done' : 'active') : 'upcoming',
      color: info.progress >= 2 ? info.color : TICKET_STATUS_COLORS.in_progress,
    },
    {
      key: 'final',
      label: isCancelled ? 'Cancelled' : 'Completed',
      date: fmt(ticket.completedOn),
      state: isTerminal ? 'done' : 'upcoming',
      color: isCancelled ? TICKET_STATUS_COLORS.cancelled : TICKET_STATUS_COLORS.completed,
    },
  ];
};
